"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _select = require("./select");

var Select = function Select(props) {
  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      open = _useState2[0],
      setOpen = _useState2[1];

  var ref = (0, _react.useRef)(null);

  var onBackgroundClick = function onBackgroundClick(e) {
    var _ref;

    e === null || e === void 0 ? void 0 : e.preventDefault();

    if (ref.current === e.target || ((_ref = e.target) === null || _ref === void 0 ? void 0 : _ref.getAttribute('name')) === props.name) {
      return;
    }

    unmount();
    setOpen(false);
  };

  var onKeyPress = function onKeyPress(e) {
    // close the dropdown on enter if it's open
    if ((e === null || e === void 0 ? void 0 : e.code) === 'Enter' && open) {
      e === null || e === void 0 ? void 0 : e.preventDefault();
      unmount();
      setOpen(false);
    }
  };

  var unmount = function unmount() {
    window.removeEventListener('click', onBackgroundClick);
    window.removeEventListener('touchend', onBackgroundClick);
    window.removeEventListener('keyup', onKeyPress);
  };

  (0, _react.useEffect)(function () {
    return unmount;
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  var onClick = function onClick(e) {
    e === null || e === void 0 ? void 0 : e.preventDefault();

    if (open) {
      unmount();
      setOpen(false);
      return;
    }

    window.addEventListener('click', onBackgroundClick);
    window.addEventListener('touchend', onBackgroundClick);
    window.addEventListener('keyup', onKeyPress);
    setOpen(true);
  };

  return _react["default"].createElement(_select.Select, (0, _extends2["default"])({}, props, {
    open: open,
    innerRef: ref,
    onClicks: {
      trigger: onClick,
      option: onClick
    }
  }));
};

var _default = Select;
exports["default"] = _default;